import { Html5QrcodeScanner, Html5Qrcode } from 'html5-qrcode';
import { useEffect } from 'react';

const qrcodeRegionId = "html5qr-code-full-region";

// Html5QrcodeScanner's built-in camera picker lists every enumerated video
// device (front and back), with no config option to filter it. It always
// gets that list through the static Html5Qrcode.getCameras(), so we patch
// that once to drop obvious front-facing cameras before the picker ever
// sees them. Device labels are the only signal enumerateDevices() exposes
// before a stream is chosen, so this is a heuristic, not an exact facing
// check - if filtering would leave no cameras at all (e.g. unlabeled
// devices on some browsers), it falls back to the full list instead of
// breaking the scanner.
let rearOnlyCameraListPatched = false;
function ensureRearOnlyCameraList() {
    if (rearOnlyCameraListPatched) {
        return;
    }
    rearOnlyCameraListPatched = true;
    const originalGetCameras = Html5Qrcode.getCameras;
    Html5Qrcode.getCameras = function (...args) {
        return originalGetCameras.apply(Html5Qrcode, args).then((cameras) => {
            const rearCameras = cameras.filter((camera) => !/front|user|face/i.test(camera.label));
            return rearCameras.length > 0 ? rearCameras : cameras;
        });
    };
}

// Creates the configuration object for Html5QrcodeScanner.
const createConfig = (props) => {
    let config = {};
    if (props.fps) {
        config.fps = props.fps;
    }
    if (props.qrbox) {
        config.qrbox = props.qrbox;
    }
    if (props.aspectRatio) {
        config.aspectRatio = props.aspectRatio;
    }
    if (props.disableFlip !== undefined) {
        config.disableFlip = props.disableFlip;
    }
    if (props.formatsToSupport !== undefined) {
        config.formatsToSupport = props.formatsToSupport;
    }
    if (props.showTorchButtonIfSupported !== undefined) {
        config.showTorchButtonIfSupported = props.showTorchButtonIfSupported;
    }
    if (props.showZoomSliderIfSupported !== undefined) {
        config.showZoomSliderIfSupported = props.showZoomSliderIfSupported;
    }
    if (props.rememberLastUsedCamera !== undefined) {
        config.rememberLastUsedCamera = props.rememberLastUsedCamera;
    }
    return config;
};

const Html5QrcodePlugin = (props) => {

    useEffect(() => {
        // when component mounts
        ensureRearOnlyCameraList();
        const config = createConfig(props);
        const verbose = props.verbose === true;
        // Suceess callback is required.
        if (!(props.qrCodeSuccessCallback)) {
            throw "qrCodeSuccessCallback is required callback.";
        }
        const html5QrcodeScanner = new Html5QrcodeScanner(qrcodeRegionId, config, verbose);
        html5QrcodeScanner.render(props.qrCodeSuccessCallback, props.qrCodeErrorCallback);
        

        // cleanup function when component will unmount
        return () => {
            html5QrcodeScanner.clear().catch(error => {
                console.error("Failed to clear html5QrcodeScanner. ", error);
            });
        };
    }, []);

    return (
        <div id={qrcodeRegionId} />
    );
};

export default Html5QrcodePlugin;
